import isBlank from "@sedan-utils/is-blank";
import { RestContentType, RestInternalError, RestResponse } from "../cutil/RestClient";
import { settings } from "../kernel/Settings";
import { ErrorUtil } from "../api/ErrorUtil";
import { eventbus } from "../cutil/Eventbus";
import { UnauthorizedMsg } from "../msg/UnauthorizedMsg";
import { StreamInternalError } from "../cutil/StreamClient";
export class BrainAdapter {
    constructor(authStore, projectStore) {
        this.authStore = authStore;
        this.projectStore = projectStore;
    }
    errorHandler(error) {
        if (error instanceof RestResponse) {
            // 提前注入错误处理函数，会被 API 的 parseError 重写
            error.parseError(res => {
                const errorFromApi = ErrorUtil.parseRestResponse(res);
                return errorFromApi || ErrorUtil.defaultErrorMsg;
            });
            if (error.status == 401) {
                this.authStore.logout();
                eventbus.emit(new UnauthorizedMsg());
            }
        }
        else if (error instanceof StreamInternalError) {
            error.parseError(res => {
                if (error.jsonData.name === ErrorUtil.abortErrorName) {
                    return ErrorUtil.defaultErrorMsg;
                }
                const errorFromApi = ErrorUtil.parseErrorData(error.jsonData).result;
                return errorFromApi || ErrorUtil.defaultErrorMsg;
            });
        }
        else if (error instanceof RestInternalError) {
            error.parseError(res => {
                /// 基本库直接抛出的错误，不用解析，直接显示默认文本
                return ErrorUtil.defaultErrorMsg;
            });
        }
    }
    get headers() {
        const brainToken = this.authStore.state.brainToken;
        const guestToken = this.authStore.state.guestToken;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let header = {
            "X-Brain-User-Tz": tz,
            "Content-Type": "application/json",
        };
        if (!isBlank(brainToken)) {
            header["Authorization"] = `token ${brainToken}`;
        }
        else if (!isBlank(guestToken)) {
            header["Brain-Guest-User-Key"] = guestToken;
        }
        const attrIndexer = this.projectStore.attrIndexer;
        if (!isBlank(attrIndexer)) {
            header["X-Brain-Imagica-Id"] = attrIndexer;
        }
        return header;
    }
    get baseUrl() {
        return settings.API;
    }
    get contentType() {
        return RestContentType.json;
    }
}
export class BrainGraphqlAdapter extends BrainAdapter {
    get baseUrl() {
        return settings.API + "/api/social/";
    }
}
